export const AppointmentContract  = {
    
    async show(id) {
        id;

        throw new Error("appointments show not implemented");
    },

    async download_product_detail_report(id) {
        id;
        
        throw new Error("appointments download_product_detail_report not implemented");
    },
    
    async operation_index(status, filter, m_type) {
        status;
        filter;
        m_type;

        throw new Error("appointments operation_index not implemented");
    },

    async set_status(id, data) {
        id;
        data;

        throw new Error("appointments set_status not implemented");
    },

    async index(status, origin, type, page, per_page, search, year){
        status;
        origin;
        type;
        page;
        per_page;
        search;
        year;
 
        throw new Error("appointments index not implemented");
    }
}